import React from "react";
import useReveal from "./useReveal";

const POSTS = [
  {
    tag: "Engineering",
    read: "5 min read",
    title: "On writing code no one else will maintain — except future you",
    excerpt:
      "Naming variables, adding comments, structuring modules — these are acts of empathy, not pedantry. A reflection on craft.",
    live: false,
  },
  {
    tag: "Stoicism",
    read: "4 min read",
    title: "What Marcus Aurelius taught me about debugging",
    excerpt:
      '"You have power over your mind, not outside events." Surprisingly useful advice for a 3am production incident.',
    live: false,
    articleKey: "marcus",
  },
  {
    tag: "Career",
    read: "6 min read",
    title: "Why I stopped calling myself a 'frontend' engineer",
    excerpt:
      "The label was a ceiling I built for myself. This is about what happens when you stop treating the boundary as fixed.",
    live: false,
  },
];

const BlogCard = ({ post, delay, onOpenArticle }) => {
  const [ref, visible] = useReveal();
  return (
    <div
      ref={ref}
      onClick={() =>
        post.live && onOpenArticle && onOpenArticle(post.articleKey)
      }
      style={{
        ...s.card,
        ...(post.live ? s.cardLive : {}),
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(18px)",
        transition: `opacity 0.6s ease ${delay}s, transform 0.6s ease ${delay}s`,
        cursor: post.live ? "pointer" : "default",
      }}
    >
      <div style={s.meta}>
        <span style={s.tag}>{post.tag}</span>
        <span>{post.read}</span>
      </div>
      <div style={s.title}>{post.title}</div>
      <div style={s.excerpt}>{post.excerpt}</div>
      <div style={post.live ? s.liveLabel : s.soonLabel}>
        {post.live ? "Read article →" : "Coming soon"}
      </div>
    </div>
  );
};

const Blog = ({ onOpenArticle }) => {
  const [labelRef, labelVisible] = useReveal();
  return (
    <section id="blog" className="section-pad" style={s.section}>
      <div
        ref={labelRef}
        style={{ opacity: labelVisible ? 1 : 0, transition: "opacity 0.5s" }}
      >
        <p style={s.label}>
          <span style={s.slash}>//</span> Writing
        </p>
      </div>
      <div className="blog-grid">
        {POSTS.map((p, i) => (
          <BlogCard
            key={p.title}
            post={p}
            delay={i * 0.1}
            onOpenArticle={onOpenArticle}
          />
        ))}
      </div>
      <p style={s.note}>
        These are drafts in spirit —{" "}
        <a href="mailto:ramakrishnakatragadda1729@gmail.com" style={s.noteLink}>
          reach out
        </a>{" "}
        if you want to read when they're published.
      </p>
    </section>
  );
};

const s = {
  section: { maxWidth: 1100, margin: "0 auto" },
  label: {
    fontSize: "0.68rem",
    letterSpacing: "0.2em",
    textTransform: "uppercase",
    color: "var(--accent)",
    marginBottom: "2.5rem",
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
  },
  slash: { color: "var(--muted)" },
  grid: {},
  card: {
    background: "var(--bg2)",
    border: "1px solid var(--border)",
    borderRadius: 6,
    padding: "2rem",
    transition: "border-color 0.2s, transform 0.2s",
  },
  cardLive: { borderColor: "rgba(192,132,252,0.25)" },
  meta: {
    fontSize: "0.65rem",
    color: "var(--muted)",
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    marginBottom: "0.75rem",
    display: "flex",
    gap: "1rem",
  },
  tag: { color: "var(--accent)" },
  title: {
    fontFamily: "var(--serif)",
    fontSize: "1.05rem",
    color: "var(--text)",
    lineHeight: 1.4,
    marginBottom: "0.75rem",
  },
  excerpt: {
    fontSize: "0.82rem",
    color: "var(--muted)",
    lineHeight: 1.85,
    marginBottom: "1rem",
  },
  soonLabel: {
    fontSize: "0.65rem",
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "var(--border2)",
    borderTop: "1px solid var(--border)",
    paddingTop: "0.75rem",
  },
  liveLabel: {
    fontSize: "0.65rem",
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "var(--accent)",
    borderTop: "1px solid rgba(192,132,252,0.2)",
    paddingTop: "0.75rem",
  },
  note: {
    textAlign: "center",
    marginTop: "2.5rem",
    fontSize: "0.78rem",
    color: "var(--muted)",
  },
  noteLink: { color: "var(--accent)", textDecoration: "none" },
};

export default Blog;
